<!--
 * @Author: DQL
 * @Date: 2022-04-08 11:37:09
 * @LastEditors: liuyixie
 * @LastEditTime: 2022-10-20 11:25:57
 * @Description: file content
-->
<template>
  <el-upload
    ref="hm-upload-inner"
    :headers="headers"
    :show-file-list="showFileList"
    :before-upload="handleBeforeUpload"
    :on-success="handleSuccess"
    :on-error="handleError"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- 默认内容 -->
    <template v-slot:default>
      <slot name="default" />
    </template>
    <!-- 触发文件选择框的内容 -->
    <template v-slot:trigger>
      <slot name="trigger" />
    </template>
    <!-- 提示说明文字 -->
    <template v-slot:tip>
      <slot name="tip" />
    </template>
    <!-- ElementUI upload的API文档中暂未提供的slot="file"说明，在例子中有使用 -->
    <template v-slot:file="slotProps">
      <slot
        name="file"
        :file="slotProps.file"
      />
    </template>
  </el-upload>
</template>

<script>
export default {
  name: 'ImportUpload',
  inheritAttrs: false,
  props: {
    prepareUrl: { // 文件预上传（初始化）地址
      type: String,
      default: null
    },
    showFileList: { // 是否显示文件列表
      type: Boolean,
      default: false
    },
    headers: { // 设置上传的请求头部
      type: Object,
      default: function () {
        return {};
      }
    },
    successAlertMsg: { // 上传成功后的弹出内容
      type: String,
      default: null
    },
    accept: { // 接受上传的[文件类型]，如“zip,jpg,png,word”
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: null
    };
  },
  methods: {
    handleClick () {
      this.$refs['hm-upload-inner'].$children[0].$refs.input.click();
    },
    /**
     * @description: 处理上传文件前的操作处理。封装了hm文件系统的“文件上传初始化功能”
     * 1. 判断是否有自定义beforeUpload方法，如果没有直接返回“文件上传初始化功能”方法到下一步。
     * 2. 如果设置了beforeUpload方法，则判断自定义的beforeUpload的返回值分别处理
     *  a. 如果返回了promise则，添加“文件上传初始化功能”到下个then处理函数中。
     *  b. 如果返回了false，则代表自定义的beforeUpload执行不通过，把false往element中继续传递。
     *  c. 如果返回了true，则代表自定义的beforeUpload执行通过，则返回“文件上传初始化功能”方法到element中继续处理。
     * @param {File} file
     * @return: Promise
     */
    handleBeforeUpload (file) {
      if (this.accept) {
        const fileEnd = file.name.split('').reverse().join('').split('.')[0].split('').reverse().join('');
        const accept = this.accept.split(',');
        if (!accept.includes(fileEnd)) {
          this.$alert(`文件格式不正确，请上传此类文件【${this.accept}】`, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: () => {
            }
          });
          return false;
        }
      }
      // 1.如果没有自定义beforeUpload事件，但定义文件预上传地址，则调用默认的“文件上传初始化功能”操作
      if (!this.$attrs['before-upload'] && this.prepareUrl) {
        return this.defaultBeforeUpload(file);
      }
      if (this.$attrs['before-upload']) {
      // 2.如果设置自定义beforeUpload事件，分三种返回值处理
        const before = this.$attrs['before-upload'](file);
        if (before && before.then && this.prepareUrl) { /* a.如果返回promise，则注册上传文件执行初始化步骤 */
          return before.then(() => {
            return this.defaultBeforeUpload(file);
          });
        } else if (before === false) { /* b.如果返回false，需要把false返回到最终处理的方法中  */
          return false;
        } else if (this.prepareUrl) { /* c.如果返回true，则需要把“文件上传初始化功能”方法返回到最终处理的方法中，到最终处理方法中先执行初始化上传操作  */
          return this.defaultBeforeUpload(file);
        }
      }
    },
    /**
     * @description: “文件上传初始化功能”
     * 按照文件系统设计，每次执行上传需要调用一次初始化操作。
     * @return: Promise
     */
    defaultBeforeUpload (file) {
      // 临时添加随机数用于避免重复
      this.$attrs.data.md5 = new Date().getTime();

      // 读取文件名设置到请求数据中
      this.$attrs.data.name = file.name;
      return this.initUpload(this.$attrs.data)
        .then((rsp) => {
          this.$attrs.data.fileId = rsp.data.fileId;
        })
        .catch((err) => {
          console.error('hmUpload组件初始化上传失败！', err);
          return Promise.reject(new Error('hmUpload组件初始化上传失败！'));
        });
    },
    /**
     * @description: 调用初始化接口
     * @param fd {object} 提交参数内容
     * @return:返回promise对象
     */
    initUpload (fd) {
      // 添加header用于传递权限信息
      return this.$axios.post(`${this.prepareUrl}`, fd, { headers: this.$attrs.headers });
    },
    /* 对element UI upload组件的methods进行封装 start */
    /**
     * @description: 清空已上传的文件列表（该方法不支持在 before-upload 中调用）
     */
    clearFiles () {
      this.$refs['hm-upload-inner'].clearFiles();
    },
    /**
     * @description: 取消上传请求
     * @param {File} file fileList 中的 file 对象
     */
    abort (file) {
      this.$refs['hm-upload-inner'].abort(file);
    },
    /**
     * @description:手动上传文件列表
     */
    submit () {
      this.$refs['hm-upload-inner'].submit();
    },
    handleSuccess (response, file, fileList) {
      const _this = this;
      if (_this.successAlertMsg) {
        _this.$alert(_this.successAlertMsg, '提示', {
          confirmButtonText: '确定',
          type: 'success',
          callback: () => {
          }
        });
        // _this.loading.close();
      }
      if (_this.$attrs['on-success']) {
        return _this.$attrs['on-success'](response, file, fileList);
      }
    },
    /**
     * @description: 上传失败
     * @param {*}
     * @return {*}
     */
    handleError (err, file, fileList) {
      const _this = this;
      _this.loading = _this.$loading({
        target: '.l-page'
      });
      if (_this.$attrs['on-error']) {
        _this.loading.close();
        return _this.$attrs['on-error'](err, file, fileList);
      } else {
        try {
          const { message } = err;
          const { errorMsg } = JSON.parse(message);
          _this.$alert(errorMsg, '提示', {
            confirmButtonText: '确定',
            type: 'error',
            callback: () => {
            }
          });
          _this.loading.close();
        } catch (error) {
          _this.loading.close();
        }
      }
    }
    /* 对element UI upload组件的methods进行封装 end */
  },
  created () {
    if (this.headers) {
      this.headers[this.$config.serverHeaderTokenName] = this.$HMCookies.get(this.$config.serverHeaderTokenName);
    }
  }
};
</script>
